/*
 * Geo-redirect controller (logic·globals).
 *
 * Reveals the geo-redirect modal for US visitors only, using the Shopify-native
 * recommended visitor country. No third-party geo service.
 *
 * Rules:
 *   - Only the section's trigger country (data-geo-country, default "US")
 *     opens the modal. MX and CA stay on billini1 (AU).
 *   - Never fires on the store the target URL points at (Productive #20402607:
 *     the US storefront was asking US visitors to go to the US store); the
 *     section also skips rendering there, this is the belt-and-braces check.
 *   - Accept  -> redirect to the section's data-geo-redirect target.
 *   - Dismiss -> hide the modal and set a one-time localStorage flag so it never
 *     re-fires for a returning shopper who declined.
 *   - Defensive: no-op if the modal isn't on the page or Shopify.country is absent.
 */
(function () {
  var STORAGE_KEY = "billini:geo-redirect-dismissed";

  function getCountry() {
    if (window.Shopify && typeof window.Shopify.country === "string") {
      return window.Shopify.country.toUpperCase();
    }
    return null;
  }

  function isDismissed() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "true";
    } catch (e) {
      return false;
    }
  }

  function setDismissed() {
    try {
      window.localStorage.setItem(STORAGE_KEY, "true");
    } catch (e) {
      /* storage unavailable — fail silently */
    }
  }

  function openModal(modal) {
    if (modal.classList.contains("is-open")) return;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("geo-redirect-open");
  }

  function closeModal(modal) {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("geo-redirect-open");
  }

  function bind(modal) {
    var accept = modal.querySelector("[data-geo-accept]");
    if (accept) {
      accept.addEventListener("click", function () {
        var target = modal.getAttribute("data-geo-redirect");
        if (target) {
          window.location.href = target;
        }
      });
    }

    var dismissers = modal.querySelectorAll("[data-geo-dismiss]");
    Array.prototype.forEach.call(dismissers, function (el) {
      el.addEventListener("click", function () {
        closeModal(modal);
        setDismissed();
      });
    });
  }

  function targetHost(modal) {
    var target = modal.getAttribute("data-geo-redirect") || "";
    try {
      return new URL(target, window.location.href).host.toLowerCase();
    } catch (error) {
      return "";
    }
  }

  function maybeOpen(modal) {
    // Trigger-country visitors only; never on the target store itself; skip if
    // the shopper has already declined.
    var trigger = (modal.getAttribute("data-geo-country") || "US").toUpperCase();
    if (getCountry() !== trigger || isDismissed()) return;
    if (targetHost(modal) === window.location.host.toLowerCase()) return;
    openModal(modal);
  }

  function init() {
    var modal = document.querySelector("[data-geo-redirect]");
    if (!modal) return;

    if (modal.dataset.geoRedirectBound !== "true") {
      bind(modal);
      modal.dataset.geoRedirectBound = "true";
    }

    maybeOpen(modal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-evaluate when the section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", init);
})();
